import { put } from 'typed-redux-saga'

import {
  setCep,
  setTipoLogradouro,
  setLogradouro,
  setBairro,
  setNumero,
  setComplemento,
  setUf,
  setCidade,
} from '@store/refinanciamento/endereco/actions'
import {
  setBancoSelecionado,
  setBancoNome,
  setTipoConta,
  setAgencia,
  setContaDadosBancarios,
  setDigito,
  setIsBankAccountEditable,
} from '@store/refinanciamento/dadosBancarios/actions'
import { BridgeService } from '@services/bridge'
import { cepMask } from '@utils/masks'
import { normalizeTipoConta } from '@utils/transformers'
import { normalizeIsValidModalityAccount } from '@utils/customerDataModality'

import { setIsValidModalityAccount } from '../actions'
import { AddressData, BankData, GetDadosPessoaisResponse } from '../types'

export { hasCompleteDadosBancarios, hasCompleteEndereco } from '@utils/customerDataCompleteness'

export function* applyAddressDataFromResponse(addressData?: AddressData | null) {
  if (!addressData) {
    return
  }

  const addr = addressData
  if (addr.zipCode && cepMask(addr.zipCode).length === 10) {
    yield* put(setCep(cepMask(addr.zipCode)))
  }
  if (addr.addressType) {
    yield* put(setTipoLogradouro(addr.addressType))
  }
  if (addr.streetAddress) {
    yield* put(setLogradouro(addr.streetAddress))
  }
  if (addr.number) {
    yield* put(setNumero(addr.number))
  }
  if (addr.additionalInfo) {
    yield* put(setComplemento(addr.additionalInfo))
  }
  if (addr.district) {
    yield* put(setBairro(addr.district))
  }
  if (addr.state) {
    yield* put(setUf(addr.state))
  }
  if (addr.city) {
    yield* put(setCidade(addr.city))
  }
}

export function* applyBankDataFromResponse(bankData?: BankData | null) {
  if (!bankData) {
    return
  }

  const bank = bankData
  if (bank.bankCode) {
    yield* put(setBancoSelecionado(bank.bankCode))
  }
  if (bank.bankName) {
    yield* put(setBancoNome(bank.bankName))
  }
  if (bank.accountType) {
    yield* put(setTipoConta(normalizeTipoConta(bank.accountType)))
  }
  if (bank.bankBranch) {
    yield* put(setAgencia(bank.bankBranch))
  }
  if (bank.accountNumber) {
    yield* put(setContaDadosBancarios(bank.accountNumber))
  }
  if (bank.accountDigit) {
    yield* put(setDigito(bank.accountDigit))
  }
}

export function* applyCustomerDataFlagsFromResponse(resp?: GetDadosPessoaisResponse) {
  if (typeof resp?.isBankAccountEditable === 'boolean') {
    yield* put(setIsBankAccountEditable(Boolean(resp.isBankAccountEditable)))
  }

  if (BridgeService.isBrowser()) {
    return
  }

  yield* put(
    setIsValidModalityAccount(normalizeIsValidModalityAccount(resp?.isValidModalityAccount)),
  )
}
